exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-active {\n    pointer-events: none;\n    cursor: default;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module id = ../../../../../src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main